export default __webpack_public_path__ + "static/media/other-modes.493c45fe.svg";